module.exports = __webpack_public_path__ + "static/media/siterraBg4.2693ca07.jpg";